"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_010_FEEDBACK_DROP_FK = void 0;
/**
 * Migration 010 (server only): drop the FK from omni_message_feedback.message_id
 * to omni_messages(id).
 *
 * The feedback table was originally designed for collab-thread messages
 * (omni_messages). In practice the like/dislike feature is used on AI chat
 * messages stored in the separate `messages` (ChatModule) table. The FK
 * caused every feedback POST to fail with a FK-violation 500 because the
 * client-side message IDs do not exist in omni_messages.
 *
 * Removing both FKs lets feedback be stored for any (tenant_id, message_id)
 * pair. In practice the chat system uses 'dev-tid' and AI message IDs that
 * don't exist in the collab tables. Application-layer guards (TenantGuard,
 * TeamsSSOGuard) are the trust boundary — the DB FKs add no protection here.
 */
const MIGRATION_010_SQL = `\
ALTER TABLE omni_message_feedback DROP CONSTRAINT IF EXISTS omni_message_feedback_message_id_fkey;
ALTER TABLE omni_message_feedback DROP CONSTRAINT IF EXISTS omni_message_feedback_tenant_id_fkey;
`;
exports.MIGRATION_010_FEEDBACK_DROP_FK = {
    id: '010_feedback_drop_fk',
    version: 10,
    name: 'drop message_id FK from omni_message_feedback',
    side: 'server',
    sql: MIGRATION_010_SQL,
};
//# sourceMappingURL=010_feedback_drop_fk.js.map